import React from 'react';
import { FaChalkboardTeacher, FaShieldAlt, FaTrophy, FaCode, FaServer } from "react-icons/fa";
import Title from '../layouts/Title';
import Card from './Card';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="What I Build & Do" des="My Focus Areas" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="Full Stack Web Apps"
          des="Build web applications from database to frontend. I use React for the interface, Node.js or FastAPI for the backend, and PostgreSQL or MongoDB for data."
          icon={<FaCode />}
        />
        <Card
          title="Secure Backend APIs"
          des="Create APIs that are hard to break. I implement proper authentication, validate inputs, enforce permissions, and design endpoints safely."
          icon={<FaServer />}
        />
        <Card
          title="API Security Testing"
          des="Test APIs for vulnerabilities. I check authentication, test for injection attacks, verify access controls, and look for misconfigurations."
          icon={<FaShieldAlt />}
        />
        <Card
          title="Fast & Scalable Code"
          des="Write code that doesn't bog down servers. Optimize database queries, implement caching, and design async workflows for high traffic."
          icon={<FaTrophy />}
        />
        <Card
          title="DevOps & Deployment"
          des="Get code running in production. I containerize with Docker, deploy to AWS, and set up monitoring so things don't break silently."
          icon={<FaCode />}
        />
        <Card
          title="Teaching & Mentoring"
          des="Help others build better code. I've run workshops on security and backend development, and mentor teams on best practices."
          icon={<FaChalkboardTeacher />}
        />
      </div>
    </section>
  );
}

export default Features;
